import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PermissionsSearchFilterQuery } from "models/filters/permissions/PermissionsSearchFilterQuery";
import { PermissionsApi } from "apis/PermissionsApi";
import { Permission } from "models/dbModels/permissions/Permission";

export const getPermissionNames = createAsyncThunk("permissionsSlice/getPermissionNames", async () => {
    const response = await PermissionsApi.PermissionNames();
    return response.data;
});

type IntiialStateType = {
    table: string[];
    loading: boolean;
};

const initialState: IntiialStateType = {
    table: [],
    loading: false,
};

const permissionsSlice = createSlice({
    name: "permissionsSlice",
    initialState: {
        ...initialState
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(getPermissionNames.fulfilled, (state, action) => {
            state.table = action.payload.data;
        });
    }
});

export default permissionsSlice.reducer;